import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from './ProgrammeListItem';

import ProgrammeStore from '../../stores/ProgrammeStore';
import ProgrammeActions from '../../actions/ProgrammeActionCreator';

class ProgrammeList extends Component {

    constructor (props) {
        super(props);
        this.state = {
            programmes: [],
            count: 0,
            page: 0,
            limit: 50
        };
        this.onChange = this.onChange.bind(this);
        this.sort = this.sort.bind(this);
    }

    componentDidMount() {
        ProgrammeStore.addChangeListener(this.onChange);
        ProgrammeActions.getAll({limit: this.state.limit});
    }

    componentWillUnmount() {
        ProgrammeStore.removeChangeListener(this.onChange);
    }

    render() {

        const isAdmin      = this.context.auth.isAdmin();
        const newEntityUrl = isAdmin ? '/dashboard/programme/new' : '';

        return (
            <ListView
                title="Training programmes"
                sortOptions={this.props.sortOptions}
                sortAction={this.sort}
                searchAction={ProgrammeActions.search}
                items={this.state.programmes}
                itemDecorator={ListItem}
                newEntityUrl={newEntityUrl}
            />
        );
    }

    onChange() {
        const programmes = ProgrammeStore.getAll();
        if (!!programmes) {
            if (programmes.length <= 1 || !this.state.sortCriteria || !this.state.sortMapCriteria) {
                this.setState({programmes});
            } else {
                const mapped = programmes.map(this.state.sortMapCriteria);
                mapped.sort(this.state.sortCriteria);
                const sortedProgrammes = mapped.map((el) => programmes[el.index]);
                this.setState({programmes: sortedProgrammes});
            }
        }
    }

    sort(options) {
        let sortCriteria, sortMapCriteria;
        switch (options.sort) {
            case 'name':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.name});
                break;
            case 'dateAdded':
                sortCriteria = (a, b) => (b.value - a.value);
                sortMapCriteria = (el, i) => ({index: i, value: Date.parse(el.dateAdded)});
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el[this.state.sort]});
        }
        this.setState({sort: options.sort, sortCriteria, sortMapCriteria});
        ProgrammeActions.getAll({sort: options.sort});
    }
}

ProgrammeList.defaultProps = {
    sortOptions: [
        {label: "Name", value: 'name'},
        {label: "Created", value: 'dateAdded'}
    ]
};

ProgrammeList.contextTypes = {
        auth: PropTypes.object.isRequired
};

export default ProgrammeList;
